import { StarSolid } from '@wfp/icons-react';
import { Text } from '@wfp/react';
import React from 'react';

import TableMain from 'src/components/TableMain';
import OperationIdCell from '../OperationIdCell';

interface Props {
  data: any[];
  filterText: (column: any) => React.ReactNode;
  filterSelect: (
    accessor: string,
    column: any,
    exact?: boolean,
  ) => React.ReactNode;
  generateReviewIcons: (
    icons: any,
    checkedStackCount: number,
    totalStackCount: number,
  ) => React.ReactNode;
  loading?: boolean;
  period?: string | number;
}

const ProjectCodeCell = ({ row }: { row: any }) => (
  <OperationIdCell row={row} />
);

const CommentsCountCell = ({ row }: { row: any }) => (
  <Text>
    {row.original.comments_count?.[0]} ({row.original.comments_count?.[1]}
    <StarSolid color="#F0CF19" description="Important" />)
  </Text>
);

const ReviewStatusTab = ({
  data,
  filterText,
  filterSelect,
  generateReviewIcons,
  loading,
  period,
}: Props) => {
  const columns = [
    {
      Header: 'Operation ID',
      accessor: 'project_code',
      id: 'project_code_column',
      Filter: (column: any) => filterText(column),
      Cell: ProjectCodeCell,
    },
    {
      Header: 'Regional Office',
      accessor: 'project_regional_bureau_display_code',
      id: 'rb_column',
      Filter: (column: any) =>
        filterSelect('project_regional_bureau_display_code', column),
    },
    {
      Header: 'Country',
      accessor: 'project_country',
      id: 'project_country_column',
      filter: 'equals',
      Filter: (column: any) => filterSelect('project_country', column, true),
    },
    {
      Header: 'Review group',
      accessor: 'review_status',
      id: 'review_status_column',
      Filter: (column: any) => filterText(column),
    },
    {
      Header: 'Due date',
      accessor: 'due_date',
      id: 'due_date_column',
      Filter: (column: any) => filterText(column),
    },
    {
      Header: 'Comments count',
      accessor: 'comments_count',
      id: 'comments_count_column',
      Cell: CommentsCountCell,
      Filter: (column: any) => filterText(column),
    },
    ...(Number(period) < 2025
      ? [
          {
            Header: 'RB review',
            accessor: 'rb_review',
            id: 'rb_review_column',
            Cell: ({ row }: { row: any }) => {
              const {
                icons,
                counters: { checked_stack_count, total_stack_count },
              } = row.original.rb_review;
              return generateReviewIcons(
                icons,
                checked_stack_count,
                total_stack_count,
              );
            },
            Filter: (column: any) => filterText(column),
          },
          {
            Header: 'HQ review',
            accessor: 'hq_review',
            id: 'hq_review_column',
            Cell: ({ row }: { row: any }) => {
              const {
                icons,
                counters: { checked_stack_count, total_stack_count },
              } = row.original.hq_review;
              return generateReviewIcons(
                icons,
                checked_stack_count,
                total_stack_count,
              );
            },
            Filter: (column: any) => filterText(column),
          },
        ]
      : []),
    ...(Number(period) >= 2025
      ? [
          {
            Header: 'Review',
            accessor: 'review',
            id: 'review_column',
            Cell: ({ row }: { row: any }) => {
              const {
                icons,
                counters: { checked_stack_count, total_stack_count },
              } = row.original.globalhq_review;
              return generateReviewIcons(
                icons,
                checked_stack_count,
                total_stack_count,
              );
            },
            Filter: (column: any) => filterText(column),
          },
        ]
      : []),
  ];

  return (
    <TableMain
      data={data}
      columns={columns}
      pagination="client"
      className="-striped -highlight"
      loading={loading}
      isFilterable
      initialState={{
        sortBy: [
          {
            id: 'project_country_column',
            desc: false,
          },
        ],
      }}
    />
  );
};

export default ReviewStatusTab;
